<template>
  <div class="checkout-wrap">
    <div class="row">
      <div class="col-12">
        <h4>Krepšelio peržiūra</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-12">
        <div class="checkout-panel checkout-panel-plans checkout-panel-main">
          <cart-lines-summary> </cart-lines-summary>
        </div>
      </div>
    </div>
    <div class="row row-address">
      <div class="col-12">
        <h4>Mokėtojas</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-12">
        <div class="checkout-panel checkout-panel-address">
          <checkout-address :countries="countries" :user="user">
          </checkout-address>
        </div>
      </div>
    </div>
    <div class="row row-payment">
      <div class="col-12">
        <h4>Mokėjimo būdas</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-12">
        <div class="checkout-panel checkout-panel-payment">
          <checkout-payment-methods> </checkout-payment-methods>
          <div class="order-totals-confirm-wrap">
            <div class="totals totals-finale">
              <div class="total-label">Viso:</div>
              <checkout-totals> </checkout-totals>
            </div>
            <div class="make-order">
              <button
                class="btn"
                @click="submitForm"
                :class="getBackgroundClass"
                :disabled="isLoading"
              >
                <transition name="fade" mode="out-in">
                  <div :class="getSpinnerClass"></div>
                </transition>
                <span class="title">Mokėti</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from 'axios'
import form from '@core/js/mixins/form'

export default {
  title: '',
  name: 'CheckoutCreateForm',
  mixins: [form],
  props: {
    modal: {
      type: Boolean,
      default: false
    },
    companies: {
      type: [Array, Object, Boolean],
      default: () => []
    },
    countries: {
      type: [Array, Object],
      default: () => []
    },
    user: {
      type: [Array, Object],
      default: () => []
    }
  },
  data() {
    return {}
  },
  computed: {
    model() {
      return this.$store.getters['getData']
    },
    isLoading() {
      return this.$store.getters['getIsLoading']
    },
    getSpinnerClass() {
      return {
        spinner: this.isLoading
      }
    },
    getBackgroundClass() {
      return {
        'is-loading': this.loading
      }
    }
  },
  async created() {},
  mounted() {
    this.$title = this.$t('checkout.titles.create')
  },
  methods: {
    submitForm() {
      this.model.isLoading = true
      this.$store
        .dispatch('proceedCheckout')
        .then(response => {
          if (response.data.data.call_url) {
            window.location.href = response.data.data.call_url
          }
        })
        .catch(error => {})
    }
  }
}
</script>
<style lang="css">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
  will-change: opacity;
}
@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}

.spinner {
  height: 20px;
  width: 20px;
  margin-right: 8px;
  opacity: 1;
  filter: alpha(opacity=100);
  animation: rotation 0.7s infinite linear;
  border: 3px solid rgba(0, 0, 0, 0.2);
  border-top-color: #0094fc;
  border-radius: 100%;
  transition: 0.3s all ease;
  position: absolute;
  left: 20px;
  top: 10px;
}
</style>
